/**
 * @generated SignedSource<<ad6fb5323c3d00d9c87e95cdb1504bca>>
 * @relayHash 2dae512862adcb75122925ebad3be592
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4513f81aaaf8e5ef12bfb3701b174a420bf76437023d3ba3827b725fad852948

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphStoreCreateProjectHasRelatedWorkWithProjectInput = {
  relationships: ReadonlyArray<GraphStoreCreateProjectHasRelatedWorkWithProjectRelationshipInput>;
};
export type GraphStoreCreateProjectHasRelatedWorkWithProjectRelationshipInput = {
  from: string;
  sequenceNumber?: AGG$Long | null | undefined;
  to: string;
  updatedAt?: AGG$DateTime | null | undefined;
};
export type useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation$variables = {
  input?: GraphStoreCreateProjectHasRelatedWorkWithProjectInput | null | undefined;
};
export type useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation$data = {
  readonly graphStore: {
    readonly createProjectHasRelatedWorkWithProject: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation = {
  response: useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation$data;
  variables: useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation",
    "selections": [
      {
        "concreteType": "GraphStoreMutation",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreCreateProjectHasRelatedWorkWithProjectPayload",
            "kind": "LinkedField",
            "name": "createProjectHasRelatedWorkWithProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation",
    "selections": [
      {
        "concreteType": "GraphStoreMutation",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreCreateProjectHasRelatedWorkWithProjectPayload",
            "kind": "LinkedField",
            "name": "createProjectHasRelatedWorkWithProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4513f81aaaf8e5ef12bfb3701b174a420bf76437023d3ba3827b725fad852948",
    "metadata": {},
    "name": "useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "2846b3362eafd7b13df7ab71229cd39c";

export default node;
